/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/**
 * @file: NavBar 组件，全屏模式下的自定义导航栏
 * @author: zhangjie13
 */

import React from 'react';
import { getCls } from '@utils/helpers';
import useDeviceInfo from '@/utils/useDeviceInfo';

import './index.scss';

const NavBarShadow = () => {
  const { statusBarHeight, getAdaptiveCssPx } = useDeviceInfo(true);

  return (
    <div
      className={`nav-bar-shadow ${getCls()}`}
      style={
        statusBarHeight > 0
          ? { paddingTop: getAdaptiveCssPx(statusBarHeight) }
          : undefined
      }
    />
  );
};

export default NavBarShadow;
